import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './BatchActionLink.scss';

export default function BatchActionLink({ className, disabled, href, children, handleClick, dataKey }) {
  const onClick = e => {
    e.preventDefault();
    handleClick(e);
  };

  if (disabled) {
    return <span className={cn('cp-batch-action-link', 'btn disabled', className)}>{children}</span>;
  }

  return (
    <a className={cn('cp-batch-action-link', className)} href={href} onClick={onClick} data-key={dataKey}>
      {children}
    </a>
  );
}

BatchActionLink.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  href: PropTypes.string.isRequired,
  children: childrenShape,
  handleClick: PropTypes.func,
  dataKey: PropTypes.string.isRequired
};
